(function(){
  const byId = id => document.getElementById(id);
  const PK = () => window.MCDUFFY_PM_PUBLIC_KEY;
  const API = () => window.MCDUFFY_BACKEND_URL;

  function pesosToCentavos(p){ return Math.round(Number(p) * 100); }

  function computePlan() {
    const cadence = byId('plan-cadence').value; // 'monthly' or 'weekly'
    const bagsPerWeek = Number(byId('bags-per-week').value || 0);
    const pricePerBag = Number(byId('price-per-bag').value || 0);
    const weeksPerCycle = cadence === 'weekly' ? 1 : 4; // simple rule
    const cyclePricePHP = bagsPerWeek * pricePerBag * weeksPerCycle;
    return {
      cadence,
      recipe: byId('plan-recipe').value,
      bagsPerWeek,
      cyclePricePHP,
      amountCentavos: pesosToCentavos(cyclePricePHP),
      description: `Gently cooked • ${byId('plan-recipe').value} • ${cadence} • ${bagsPerWeek} bags/week`
    };
  }

  async function createPaymentMethod(billing) {
    const body = {
      data: { attributes: {
        type: "card",
        details: {
          card_number: byId('card-number').value.replace(/\s+/g,''),
          exp_month: parseInt(byId('exp-month').value,10),
          exp_year: parseInt(byId('exp-year').value,10),
          cvc: byId('cvc').value
        },
        billing
      }}
    };
    const r = await fetch('https://api.paymongo.com/v1/payment_methods', {
      method: 'POST',
      headers: {
        'Authorization': 'Basic ' + btoa(PK() + ':'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    const j = await r.json();
    if (!r.ok) throw j;
    return j.data.id;
  }

  async function attachPaymentIntent(piId, clientKey, pmId, returnUrl) {
    const r = await fetch(`https://api.paymongo.com/v1/payment_intents/${piId}/attach`, {
      method: 'POST',
      headers: { 'Authorization': 'Basic ' + btoa(PK() + ':'), 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: { attributes: { payment_method: pmId, client_key: clientKey, return_url: returnUrl }}})
    });
    const j = await r.json();
    if (!r.ok) throw j;
    const na = j?.data?.attributes?.next_action;
    if (na && na.redirect && na.redirect.url) {
      location.href = na.redirect.url; // 3DS step
    } else {
      location.href = returnUrl + `?pi=${encodeURIComponent(piId)}&ok=1`;
    }
  }

  async function subscribe() {
    const msg = byId('msg');
    msg.textContent = 'Preparing your subscription…';

    // Collect customer + shipping
    const customer = {
      email: byId('cust-email').value,
      first_name: byId('cust-first').value,
      last_name: byId('cust-last').value,
      phone: byId('cust-phone').value
    };
    const shippingAddress = {
      firstName: byId('cust-first').value,
      lastName: byId('cust-last').value,
      address1: byId('addr-1').value,
      city: byId('addr-city').value,
      country: byId('addr-country').value,
      zip: byId('addr-zip').value
    };
    const plan = computePlan();

    // Build Shopify order blueprint
    const shopifyOrder = {
      currency: "PHP",
      email: customer.email,
      lineItems: [
        {
          title: `McDuffy Gently Cooked — ${plan.recipe} (${plan.cadence})`,
          quantity: 1,
          priceSet: { shopMoney: { amount: Number(plan.cyclePricePHP), currencyCode: "PHP" } }
        }
      ],
      amount: Number(plan.cyclePricePHP),
      note: "PayMongo subscription",
      tags: ["subscription","PayMongo"],
      shippingAddress
    };

    // Call your backend to create customer+subscription and return PI + client_key
    const resp = await fetch(API() + '/api/paymongo/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customer,
        plan: {
          name: `Gently cooked • ${plan.recipe} • ${plan.cadence}`,
          description: plan.description,
          amount: plan.amountCentavos,
          currency: 'PHP',
          interval: plan.cadence,
          interval_count: 1
        },
        shopifyOrder
      })
    });
    const data = await resp.json();
    if (!resp.ok) throw data;

    // Create Payment Method in browser with public key
    const billing = {
      name: `${customer.first_name} ${customer.last_name}`,
      email: customer.email,
      phone: customer.phone,
      address: { line1: shippingAddress.address1, city: shippingAddress.city, postal_code: shippingAddress.zip, country: shippingAddress.country }
    };
    const pmId = await createPaymentMethod(billing);

    // Attach to PI (triggers 3DS if required)
    const returnUrl = `${location.origin}/pages/paymongo-return`;
    await attachPaymentIntent(data.paymentIntentId, data.clientKey, pmId, returnUrl);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const btn = document.getElementById('btn-subscribe');
    if (btn) btn.addEventListener('click', async () => {
      const msg = document.getElementById('msg');
      msg.textContent = '';
      try {
        await subscribe();
      } catch (e) {
        console.error(e);
        msg.textContent = 'Payment failed. Check your details and try again.';
      }
    });
  });
})();
